import { Link } from "react-router-dom";
import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import PageTitle from "../Component/PageTitle";
import { Accordion } from "react-bootstrap"; // Ensure react-bootstrap is installed
import { Table } from "react-bootstrap";

const Howtoapply = () => {
  const homeMenu = [
    { label: "Admission Notification ", link: "/howtoapply" },
    { label: "Fee Structure", link: "/feestructure" },
    { label: "Prospectus ", link: "/Prospectus" },
    {
      label: "Virtual School Tour ",
      link: "https://iviewd.com/lotus_valley_gurgaon/",
    },
    { label: "School Schedule ", link: "/schoolSchedule" },
    {
      label: "Transport",
      link: "",
      subMenu: [
        { label: "Transport", link: "/transport" },
        { label: "Bus Routes", link: "/busRoute" },
      ],
    },
    { label: "Special Education", link: "/specialEdu" },
    { label: "Bonding With Parents", link: "/bondingwithparents" },
    {
      label: "Meal Menu",
      link: "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/School-Menu.pdf",
    },
    { label: "CBSE Results", link: "/CBSEResult" },
    { label: "Transfer Certificate", link: "/tc" },
  ];

  const HOW_TO_APPLY = [
    "/Images/how_to_apply_1.jpg",
    "/Images/how_to_apply_2.jpg",
    "/Images/how_to_apply_3.jpg",
  ];

  const HOW_TO_APPLY_map = HOW_TO_APPLY.map(function (item, index, arr) {
    return (
      <img
        src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public${item}`}
        className="mx-auto d-block img-fluid"
      />
    );
  });

  return (
    <>
      <Header />
      <Breadcrumb breadImage="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/apply.jpg" />
      <Menu MenuItem={homeMenu} />

      <div className="padding-blk inner-page admission">
        <div className="container-fluid online_rg_main">
          <div className="row">
            <div className="col-md-12">
              <PageTitle
                pageTitle="How to Apply"
                breadEnd="How to Apply"
                breadMid="How to Apply"
              />
              <div className="online_reg">
                {" "}
                <a                
                  className="online-registration-btn"
                >
                  Admission Closed FS-I & FS-II | Academic Session 2027–28
                </a>
              </div>
            </div>
            <p>
              We sincerely thank all prospective parents for considering                <b> Lotus Valley International School, Gurugram and for placing their trust in us.</b>  <br/>
We truly wish we could accommodate every child who aspires to be a part of our school. However, due to the <b> limited number of seats available, </b>we are unable to accommodate all applicants for the session. <br/>
We hope to have the opportunity to welcome you to the <b> Lotus Valley family </b>in the future. <br/>
With warm regards<br/>
<b> Anita Malhotra</b><br/>
(Director)
            </p>
            <div className="col-md-12">
              <Accordion defaultActiveKey="0">
                {/* Admission Notification */}
                {/* {HOW_TO_APPLY_map} */}
                {/* <Accordion.Item eventKey="0">
                  <Accordion.Header>Registration for Admission Opens for Grades XI</Accordion.Header>
                  <Accordion.Body>
                    <div className="text-center">
                      <h4>Admission Notification – Academic Session 2026-27</h4>
                      <h4 className="color-blue font-normal">
                        Registration for Admission Opens for Grades XI
                      </h4>
                    </div>
                    <p>
                      <b> Registration forms</b> can be collected from the School Reception / downloaded from the School Website.
                    </p>
                    <p>Duly filled in Registration Forms complete in all respect must be submitted at the School Reception with the relevant documents mentioned below.</p>
                    <ul class="admission-list">
                      <li>The Registration fee amount is non-refundable</li>
                      <li>Filling and submission of Registration form does not guarantee admission to the school</li>
                      <li> All valid applications will be considered for Admissions.</li>
                      <li>Progress Report of Grade IX attended to be submitted, Pre-Board Results of Grade X & CBSE-Board results of Grade X.</li>
                      <li> There will be written assessment, and a meeting with the Director.</li>
                      <li>Admission will be granted subject to clearing of the written assessment.</li>
                      <li> Seats are subject to vacancy and due process.</li>
                      <li> Admission will be granted post verification of documents.</li>
                      <li>Payment of fee within 2 days after confirmation of admission. In case of any Non-Compliance the admission will stand cancelled</li>
                    </ul>
                    <h4 className="mt-4 color-blue">Eligibility Criteria:</h4>
                    <p>Science Stream: Aggregate 85%,<br />
                      ESM 85% (English, Math & Science)<br />
                      Commerce & Humanities: Aggregate 80%<br />
                      The streams are available and the eligibility criteria are given below for your</p>
                    <p><b>reference:</b></p>
                    <h4 className="mt-4 color-blue">SCHOOL OFFERS THE FOLLOWING SUBJECT STREAMS FOR GRADE XI:</h4>
                    <div className="table-responsive mb-4">
                      <h4 className="mb-3 color-blue">Grade XI Subject Streams</h4>
                      <Table striped bordered hover responsive>
                        <thead>
                          <tr>
                            <th>Grade XI</th>
                            <th>SCIENCE</th>
                            <th>COMMERCE</th>
                            <th>HUMANITIES</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td rowSpan={3}><b>Compulsory Subjects</b></td>
                            <td>1. English Core (301)<br />
                              2. Physics (042)<br />
                              3. Chemistry (043)</td>
                            <td>1. English Core (301)<br />
                              2. Accountancy (055)<br />
                              3. Business Studies (054)</td>
                            <td>
                              1. English Core (301)<br />
                              2. Political Science (028)<br />
                              3. History (027)
                            </td>
                          </tr>

                          <tr>

                            <td>
                              <p><b>4.</b></p>
                              <ul className="admission-list">
                                <li>Economics (030)/   </li>
                                <li>Biology (044)/   </li>
                                <li>Computer Science (083)/   </li>
                                <li>Legal Studies (074)/   </li>
                                <li>Mathematics (041)/   </li>
                                <li>Design Thinking &Innovation (848)/   </li>
                                <li>Artificial Intelligence (843)   </li>
                              </ul>
                              <p><b>ANY ONE</b></p>
                            </td>




                            <td> <p><b>4.</b></p>
                              <ul className="admission-list">
                                <li> Economics (030)/</li>
                                <li> Legal Studies (074)/</li>
                                <li> Computer Science (083)/</li>
                                <li>  Mathematics (041)/</li>
                                <li>  Design Thinking & Innovation (848)/</li>
                                <li>  Artificial Intelligence (843)</li>
                              </ul>
                              <p><b>ANY ONE</b></p></td>
                            <td>
                              <p><b>4.</b></p>
                              <ul className="admission-list">
                                <li> Economics (030)/</li>
                                <li> Legal Studies (074)/</li>
                                <li>Mathematics (041)/</li>
                                <li> Design Thinking & Innovation (848)/</li>
                                <li>Artificial Intelligence (843)</li>
                              </ul>
                              <p><b>ANY ONE</b></p></td>
                          </tr>

                          <tr>
                            <td> <p><b>5.</b></p>
                              <ul className="admission-list">
                                <li>  Mathematics (041)</li>
                                <li> Applied Mathematics (241)</li>
                                <li> Psychology (037)</li>
                                <li> Painting (049)</li>
                                <li> Physical Education (048)</li>
                              </ul>
                              <p><b>ANY ONE</b></p></td>


                            <td><p><b>5.</b></p>
                              <ul className="admission-list">
                                <li>Mathematics (041)</li>
                                <li>Applied Mathematics (241)</li>
                                <li> Psychology (037)</li>
                                <li> Painting (049)</li>
                                <li> Physical Education (048)</li>
                              </ul>
                              <p><b>ANY ONE</b></p></td>
                            <td>

                              <p><b>5.</b></p>
                              <ul className="admission-list">
                                <li>Mathematics (041)</li>
                                <li> Applied Mathematics (241)</li>
                                <li>  Psychology (037)</li>
                                <li> Painting (049)</li>
                                <li> Physical Education (048)</li>
                              </ul>
                              <p><b>ANY ONE</b></p></td>
                          </tr>

                          <tr>
                            <td><b>Optional subject</b></td>
                            <td>
                              <ul className="admission-list">
                                <li>Psychology (037) *</li>
                                <li>Physical Education (048) *</li>
                                <li> Hindi</li>
                              </ul>
                              <p><b>ANY ONE</b></p>
                            </td>
                            <td>
                              <ul className="admission-list">
                                <li> Psychology (037) *</li>
                                <li> Physical Education (048) *</li>
                                <li> Hindi</li>
                              </ul>
                              <p><b>ANY ONE</b></p>
                            </td>

                            <td>
                              <ul className="admission-list">
                                <li>Psychology (037) *</li>
                                <li>  Physical Education (048) *</li>
                                <li>  Hindi</li>
                              </ul>
                              <p><b>ANY ONE</b></p>
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                    <p><b>You are requested to give your choice of subjects <u>after a serious discussion and deliberation with your ward.</u> It is utmost important to consider the <u>aptitude of your ward</u> and performance in the respective subjects.</b></p>
                    <h4 className="mb-3 color-blue">Pre-requisites at the time of submission of Registration Form</h4>
                    <Table striped bordered hover responsive>
                      <thead>
                        <tr>
                          <th>CRITERIA</th>
                          <th>DOCUMENTS TO BE SUBMITTED</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr><td><b>Proof of Age</b></td>
                          <td>
                            <ul className="admission-list">
                              <li>Copy of Birth Certificate <b>(Mandatory</b></li>
                              <li>Passport Copy (in case name not mentioned in Birth certificate)</li>
                              <li> Copy of Adhaar card</li>
                            </ul>
                          </td>
                        </tr>

                        <tr><td><b>Proof of Residence</b></td>
                          <td>
                            <ul className="admission-list">
                              <li>  Passport</li>
                              <li> Lease Deed</li>
                              <li>  Bank Statement/passbook</li>
                              <li>   Utility Bill (water, electricity, phone)</li>
                              <li>  Rent Agreement/ Deed</li>
                              <p> <b>(ANY ONE OF THE ABOVE)</b></p>
                            </ul>
                          </td>
                        </tr>
                        <tr>
                          <td><b>Report Card</b></td>
                          <td>
                            <ul className="admission-list">
                              <li> Report Card of the last class attended</li>
                              <li> Final Term Report Card of the Grade IX</li>
                              <li> Pre Board & Board result of Grade X for admission to Grade XI</li>
                              <li> Recommendation Letter</li>
                              <li>  Transfer Certificate at the time of joining School</li>
                            </ul>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </Accordion.Body >
                </Accordion.Item > */}
                <Accordion.Item eventKey="1">
                  {/* <Accordion.Header>Registrations for Admission Opens for
                    FOUNDATIONAL STAGES- FS1 / FS2 / Grade-I</Accordion.Header> */}

                  {/* <Accordion.Body>
                    <div className="text-center">
                      <h4>Admission Notification – Academic Session (2026-27)</h4>
                      <h4><span>Registrations for Admission Opens for</span></h4>
                      <h4 className="color-blue font-normal">
                        FOUNDATIONAL STAGES- FS1 / FS2 / Grade-I
                      </h4>
                    </div>
                    <p>
                      The age eligibility criteria as on 1st April 2026 is in
                      alignment with NEP guidelines (strictly abiding)
                    </p>
                    <ul class="admission-list">
                      <li className="">FS 1 is 3+yrs</li>
                      <li className="">FS 2 is 4+yrs</li>
                      <li className="">FS 3 is 5+yrs ( NO VACANCY)</li>
                      <li className="">Grade1 6+yrs</li>
                    </ul>
                    <div className="text-center">
                      <h4 className="color-blue text-left">
                        Registration Forms will be available online for Admission
                        w.e.f. 28th to 31st July’2025.
                      </h4>
                    </div>
                    <p>
                      {" "}
                      Duly filled in <strong>Registration Form</strong> completed in
                      all respects must be submitted online{" "}
                      <strong>
                        <em>
                          <u>
                            latest by Thursday, 31<sup>st</sup> July 2025 (12:00pm
                            midnight) <br />{" "}
                          </u>
                        </em>
                      </strong>{" "}
                    </p>
                    <h4 className="color-blue text-left">
                      No forms will be accepted later than the given date.
                    </h4>
                    <ul class="admission-list">
                      <li>
                        Filling and submission of online Registration Form{" "}
                        <span className="color-blue">
                          does not guarantee admission{" "}
                        </span>
                        to the school.
                      </li>
                      <li className="color-blue text-left">
                        The Registration fee amount is non-refundable
                      </li>
                      <li>
                        All valid applications will be considered for Admission.
                      </li>
                      <li>
                        Incomplete / Incorrect Registration Form will not be
                        processed.
                      </li>
                      <li>
                        There will be no screening, written test, interview or
                        profiling of child/parent.
                      </li>
                      <li className="color-blue">
                        Priority will be given to children fulfilling the Age &
                        Neighborhood criteria (FS1/FS2)
                      </li>
                      <li>
                        In case there is no vacancy, the application will not be
                        processed.
                      </li>
                      <li>
                        Admission will be granted post verification of documents &
                        online Registration Form submitted
                      </li>
                      <li>
                        The{" "}
                        <u className="color-blue">
                          Fee payment should be made within 2 days{" "}
                        </u>
                        after confirmation of Admission .
                      </li>
                    </ul>
                    <p>
                      <i>
                        <span>
                          <b>
                            In case of any Non-Compliance, the admission will stand
                            cancelled.
                          </b>
                        </span>
                      </i>
                    </p>
                    <ul class="admission-list">
                      <li>
                        The Mode of payment for Admission has to be through{" "}
                        <b className="color-blue"> NEFT / DEMAND DRAFT</b> only in
                        favour of{" "}
                        <span className="color-blue">
                          <i>Lotus Valley International School, Gurgaon</i>.
                        </span>
                      </li>
                    </ul>
                    <h4 className="color-blue mb-4">
                      Pre-requisites at the time of submission of Admission Form
                    </h4>
                    <div className="table-responsive strong-color howtbl">
                      <table cellpadding="0" cellspacing="0" width="100%" border="1">
                        <tbody>
                          <tr>
                            <td>
                              <p className="mb-0">
                                <strong>
                                  <span>CRITERIA</span>
                                </strong>
                              </p>
                            </td>
                            <td>
                              <p className="mb-0">
                                <strong>
                                  <span>DOCUMENTS TO BE SUBMITTED (MADATORY)</span>
                                </strong>
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p>
                                <strong>
                                  <span>Mode of Payment</span>
                                </strong>
                              </p>
                            </td>
                            <td>
                              <ul class="admission-list">
                                <li>
                                  Parents should carry Demand Draft of the said
                                  mentioned amount at the time of submission of
                                  Admission Form.
                                </li>
                                <li>
                                  Transfer of fee through NEFT as per the under
                                  mentioned details:{" "}
                                </li>
                              </ul>
                              <p className="color-blue">
                                Account Holder’s - Name
                                <br />
                                Lotus Valley International School, Gurgaon <br />
                                Account number - '628401064387 <br />
                                IFSC Code - ICIC0006284
                                <br />
                                Bank’s Name - ICICI BANK
                              </p>
                              <ul class="admission-list">
                                <li>
                                  Also confirm the same sending the screen shot of the
                                  payment at:{" "}
                                </li>
                              </ul>
                              <p>
                                <Link
                                  to="mailto:Info@lotusvalleygurgaon.com"
                                  target="_blank"
                                  rel="noreferrer"
                                  className="color-blue"
                                >
                                  admissions@lotusvalleygurgaon.com
                                </Link>
                                <strong> </strong>
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p>
                                <strong>Photographs</strong>
                                <br />
                                <strong>
                                  (at the time of submission of Admission Form)
                                </strong>
                              </p>
                            </td>
                            <td>
                              <ul class="admission-list">
                                <li>2 recent photographs of the child</li>
                              </ul>
                              <p> </p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p>
                                <strong>Proof of Age&nbsp; (Self Attested)</strong>
                              </p>
                            </td>
                            <td>
                              <ul class="admission-list">
                                <li>
                                  Copy of the Birth Certificate
                                  <strong className="color-blue">(mandatory)</strong>
                                </li>
                                <li>
                                  Passport (in case name not mentioned in Birth
                                  certificate)-optional{" "}
                                </li>
                                <li>
                                  Copy of Aadhaar&nbsp; Card{" "}
                                  <strong className="color-blue">(mandatory</strong>
                                  ){" "}
                                </li>
                              </ul>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p>
                                <strong>Proof of Residence</strong>
                                <br />
                                <strong>(any one of the mentioned documents)</strong>
                              </p>
                            </td>
                            <td>
                              <ul class="admission-list">
                                <li>Passport</li>
                                <li>Lease Deed</li>
                                <li>Bank Statement/passbook</li>
                                <li>Utility Bill (water, electricity, phone)</li>
                                <li>Rent Agreement/ Deed</li>
                              </ul>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <h4 className="mt-4 color-blue">
                      <u>Withdrawal Guidelines:</u>
                    </h4>
                    <ul className="admission-list">
                      <li>
                        Please Note that{" "}
                        <span className="color-blue">
                          Admission Fee is a non-refundable component{" "}
                        </span>
                        and will not be refunded in case of withdrawal or request at
                        any time of the year.
                      </li>
                      <li>
                        As per school rules in case of withdrawal 2 months’ prior
                        intimation is required before the start of the new academic
                        session <span>(new admission).</span> Failing which only
                        caution money will be refunded rest all components would be
                        forfeited.
                      </li>
                    </ul>

                  </Accordion.Body> */}
                </Accordion.Item>
                {/* <Accordion.Item eventKey="2">
                  <Accordion.Header>Pre-requisites at the time of submission</Accordion.Header>
                  <Accordion.Body>
                    <ul className="admission-list">
                      <li>The Mode of payment for Admission has to be through <b className="color-blue">NEFT / DEMAND DRAFT</b> only in favour of <span className="color-blue"><i>Lotus Valley International School, Gurgaon</i></span>.</li>
                    </ul>
                    <h4 className="color-blue mb-4">Pre-requisites at the time of submission of Admission Form</h4>
                    <div className="table-responsive strong-color howtbl">
                      <table className="table table-bordered">
                        <tbody>
                          <tr>
                            <td><strong>CRITERIA</strong></td>
                            <td><strong>DOCUMENTS TO BE SUBMITTED (MANDATORY)</strong></td>
                          </tr>
                          <tr>
                            <td><strong>Mode of Payment</strong></td>
                            <td>
                              <ul className="admission-list">
                                <li>Parents should carry Demand Draft of the said mentioned amount at the time of submission of Admission Form.</li>
                                <li>Transfer of fee through NEFT as per the under mentioned details:</li>
                              </ul>
                              <p className="color-blue">
                                Account Holder’s - Name: Lotus Valley International School, Gurgaon <br />
                                Account number - '628401064387 <br />
                                IFSC Code - ICIC0006284 <br />
                                Bank’s Name - ICICI BANK
                              </p>
                              <ul className="admission-list">
                                <li>Also confirm the same sending the screen shot of the payment at: <Link to="mailto:admissions@lotusvalleygurgaon.com" className="color-blue">admissions@lotusvalleygurgaon.com</Link></li>
                              </ul>
                            </td>
                          </tr>
                          <tr>
                            <td><strong>Photographs</strong><br /><strong>(at the time of submission of Admission Form)</strong></td>
                            <td>
                              <ul className="admission-list"><li>2 recent photographs of the child</li></ul>
                            </td>
                          </tr>
                          <tr>
                            <td><strong>Proof of Age (Self Attested)</strong></td>
                            <td>
                              <ul className="admission-list">
                                <li>Copy of the Birth Certificate <strong className="color-blue">(mandatory)</strong></li>
                                <li>Passport (optional)</li>
                                <li>Copy of Aadhaar Card <strong className="color-blue">(mandatory)</strong></li>
                              </ul>
                            </td>
                          </tr>
                          <tr>
                            <td><strong>Proof of Residence</strong><br /><strong>(any one of the mentioned documents)</strong></td>
                            <td>
                              <ul className="admission-list">
                                <li>Passport / Lease Deed / Bank Statement / Utility Bill / Rent Agreement/Deed</li>
                              </ul>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="3">
                  <Accordion.Header>Withdrawal Guidelines</Accordion.Header>
                  <Accordion.Body>
                    <ul className="admission-list">
                      <li>Please Note that <span className="color-blue">Admission Fee is a non-refundable component</span> and will not be refunded in case of withdrawal or request at any time of the year.</li>
                      <li>As per school rules in case of withdrawal 2 months’ prior intimation is required before the start of the new academic session <span>(new admission)</span>. Failing which only caution money will be refunded rest all components would be forfeited.</li>
                    </ul>
                  </Accordion.Body>
                </Accordion.Item> */}
              </Accordion>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Howtoapply;
